/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Components_Storedropdown_Viewstorepage3Inputs */

const id_components_storedropdown_viewstorepage3 = /** @type {(inputs: Components_Storedropdown_Viewstorepage3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lihat Halaman Toko`)
};

const ms_components_storedropdown_viewstorepage3 = /** @type {(inputs: Components_Storedropdown_Viewstorepage3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lihat Halaman Kedai`)
};

const da_components_storedropdown_viewstorepage3 = /** @type {(inputs: Components_Storedropdown_Viewstorepage3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Se Butiksside`)
};

const de_components_storedropdown_viewstorepage3 = /** @type {(inputs: Components_Storedropdown_Viewstorepage3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Store-Seite anzeigen`)
};

const en_us2_components_storedropdown_viewstorepage3 = /** @type {(inputs: Components_Storedropdown_Viewstorepage3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`View Store Page`)
};

const es_es2_components_storedropdown_viewstorepage3 = /** @type {(inputs: Components_Storedropdown_Viewstorepage3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ver página de la tienda`)
};

const es_mx2_components_storedropdown_viewstorepage3 = /** @type {(inputs: Components_Storedropdown_Viewstorepage3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ver página de la tienda`)
};

const fil_components_storedropdown_viewstorepage3 = /** @type {(inputs: Components_Storedropdown_Viewstorepage3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tingnan ang Pahina ng Tindahan`)
};

const fr_components_storedropdown_viewstorepage3 = /** @type {(inputs: Components_Storedropdown_Viewstorepage3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voir la page de la boutique`)
};

const it_components_storedropdown_viewstorepage3 = /** @type {(inputs: Components_Storedropdown_Viewstorepage3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vedi pagina del negozio`)
};

const hu_components_storedropdown_viewstorepage3 = /** @type {(inputs: Components_Storedropdown_Viewstorepage3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bolt oldal megtekintése`)
};

const nl_components_storedropdown_viewstorepage3 = /** @type {(inputs: Components_Storedropdown_Viewstorepage3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bekijk winkelpagina`)
};

const no_components_storedropdown_viewstorepage3 = /** @type {(inputs: Components_Storedropdown_Viewstorepage3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vis butikkside`)
};

const pl_components_storedropdown_viewstorepage3 = /** @type {(inputs: Components_Storedropdown_Viewstorepage3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zobacz stronę w sklepie`)
};

const pt_br2_components_storedropdown_viewstorepage3 = /** @type {(inputs: Components_Storedropdown_Viewstorepage3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`View Store Page`)
};

const pt_components_storedropdown_viewstorepage3 = /** @type {(inputs: Components_Storedropdown_Viewstorepage3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ver página da loja`)
};

const ro_components_storedropdown_viewstorepage3 = /** @type {(inputs: Components_Storedropdown_Viewstorepage3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vezi pagina magazinului`)
};

const fi_components_storedropdown_viewstorepage3 = /** @type {(inputs: Components_Storedropdown_Viewstorepage3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Näytä kauppasivu`)
};

const sv_components_storedropdown_viewstorepage3 = /** @type {(inputs: Components_Storedropdown_Viewstorepage3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Visa butikssida`)
};

const vi_components_storedropdown_viewstorepage3 = /** @type {(inputs: Components_Storedropdown_Viewstorepage3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Xem trang cửa hàng`)
};

const tr_components_storedropdown_viewstorepage3 = /** @type {(inputs: Components_Storedropdown_Viewstorepage3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mağaza Sayfasını Görüntüle`)
};

const cs_components_storedropdown_viewstorepage3 = /** @type {(inputs: Components_Storedropdown_Viewstorepage3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zobrazit stránku obchodu`)
};

const bg_components_storedropdown_viewstorepage3 = /** @type {(inputs: Components_Storedropdown_Viewstorepage3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Преглед на страницата на магазина`)
};

const ru_components_storedropdown_viewstorepage3 = /** @type {(inputs: Components_Storedropdown_Viewstorepage3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Просмотр страницы магазина`)
};

const uk_components_storedropdown_viewstorepage3 = /** @type {(inputs: Components_Storedropdown_Viewstorepage3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Переглянути сторінку магазину`)
};

const ar_components_storedropdown_viewstorepage3 = /** @type {(inputs: Components_Storedropdown_Viewstorepage3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`عرض صفحة المتجر`)
};

const hi_components_storedropdown_viewstorepage3 = /** @type {(inputs: Components_Storedropdown_Viewstorepage3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`स्टोर पेज देखें`)
};

const th_components_storedropdown_viewstorepage3 = /** @type {(inputs: Components_Storedropdown_Viewstorepage3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ดูหน้าร้านค้า`)
};

const ja_components_storedropdown_viewstorepage3 = /** @type {(inputs: Components_Storedropdown_Viewstorepage3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ストアページを見る`)
};

const zh_cn2_components_storedropdown_viewstorepage3 = /** @type {(inputs: Components_Storedropdown_Viewstorepage3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`View Store Page`)
};

const zh_hant1_components_storedropdown_viewstorepage3 = /** @type {(inputs: Components_Storedropdown_Viewstorepage3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`View Store Page`)
};

const ko_components_storedropdown_viewstorepage3 = /** @type {(inputs: Components_Storedropdown_Viewstorepage3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`View Store Page`)
};

/**
* | output |
* | --- |
* | "View Store Page" |
*
* @param {Components_Storedropdown_Viewstorepage3Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const components_storedropdown_viewstorepage3 = /** @type {((inputs?: Components_Storedropdown_Viewstorepage3Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Storedropdown_Viewstorepage3Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_components_storedropdown_viewstorepage3(inputs)
	if (locale === "ms") return ms_components_storedropdown_viewstorepage3(inputs)
	if (locale === "da") return da_components_storedropdown_viewstorepage3(inputs)
	if (locale === "de") return de_components_storedropdown_viewstorepage3(inputs)
	if (locale === "en-US") return en_us2_components_storedropdown_viewstorepage3(inputs)
	if (locale === "es-ES") return es_es2_components_storedropdown_viewstorepage3(inputs)
	if (locale === "es-MX") return es_mx2_components_storedropdown_viewstorepage3(inputs)
	if (locale === "fil") return fil_components_storedropdown_viewstorepage3(inputs)
	if (locale === "fr") return fr_components_storedropdown_viewstorepage3(inputs)
	if (locale === "it") return it_components_storedropdown_viewstorepage3(inputs)
	if (locale === "hu") return hu_components_storedropdown_viewstorepage3(inputs)
	if (locale === "nl") return nl_components_storedropdown_viewstorepage3(inputs)
	if (locale === "no") return no_components_storedropdown_viewstorepage3(inputs)
	if (locale === "pl") return pl_components_storedropdown_viewstorepage3(inputs)
	if (locale === "pt-BR") return pt_br2_components_storedropdown_viewstorepage3(inputs)
	if (locale === "pt") return pt_components_storedropdown_viewstorepage3(inputs)
	if (locale === "ro") return ro_components_storedropdown_viewstorepage3(inputs)
	if (locale === "fi") return fi_components_storedropdown_viewstorepage3(inputs)
	if (locale === "sv") return sv_components_storedropdown_viewstorepage3(inputs)
	if (locale === "vi") return vi_components_storedropdown_viewstorepage3(inputs)
	if (locale === "tr") return tr_components_storedropdown_viewstorepage3(inputs)
	if (locale === "cs") return cs_components_storedropdown_viewstorepage3(inputs)
	if (locale === "bg") return bg_components_storedropdown_viewstorepage3(inputs)
	if (locale === "ru") return ru_components_storedropdown_viewstorepage3(inputs)
	if (locale === "uk") return uk_components_storedropdown_viewstorepage3(inputs)
	if (locale === "ar") return ar_components_storedropdown_viewstorepage3(inputs)
	if (locale === "hi") return hi_components_storedropdown_viewstorepage3(inputs)
	if (locale === "th") return th_components_storedropdown_viewstorepage3(inputs)
	if (locale === "ja") return ja_components_storedropdown_viewstorepage3(inputs)
	if (locale === "zh-CN") return zh_cn2_components_storedropdown_viewstorepage3(inputs)
	if (locale === "zh-Hant") return zh_hant1_components_storedropdown_viewstorepage3(inputs)
	return ko_components_storedropdown_viewstorepage3(inputs)
});
export { components_storedropdown_viewstorepage3 as "components.storeDropdown.viewStorePage" }